<template>
    <div class="land-main" v-if="salesCardPage != null && salesCard != null">
        <div class="container">
            <div class="land-main-items">
                <!-- && projectNameG != 'aqualina' -->
                <div class="item" v-if="salesCard.project_stie_shablon_price_flats_init == 'true'">
                    <div class="item-img">
                        <img :src="salesCardPage.land_cards[0].icon" alt="">
                    </div>
                    <div class="item-title">
                        <p>{{salesCardPage.land_cards[0].name}}</p>
                    </div>
                    <div class="item-info">
                        <strong>{{salesCard.project_land_site.land_cards[0].info}}</strong>
                        <!-- <strong v-if="objectDataCRM != null">{{getNumber(objectDataCRM.minMeterPrice)}} <span class="small">тыс.тг м²</span></strong> -->
                    </div>
                </div>
                <div class="item" v-for="(item, index) in salesCardPage.land_cards" :key="index" v-if="index != 0 && salesCard.project_land_site.land_cards != false && salesCard.project_land_site.land_cards != null">
                    <div class="item-img">
                        <img :src="item.icon" alt="">
                    </div>
                    <div class="item-title">
                        <p>{{item.name}}</p>
                    </div>
                    <div class="item-info">
                        <strong>{{salesCard.project_land_site.land_cards[index].info}}</strong>
                    </div>
                </div>
            </div>
        </div>
    </div>   
</template>

<script>
    import {mapGetters} from 'vuex'
    // import PROMOpage from '@/components/sales/sales-promo-page.vue'
    export default {
        name: 'sale-land-main',
        components: {
        },
        data () {
            return {
                projectNameG: window.host,
            }
        },
        computed: mapGetters({
            salesCard: 'loadSalesCardContent',
            salesCardPage: 'loadSalesCardPage',
            objectDataCRM: 'loadObjectDataCrm',
        }),
        methods: {
            getNumber(n) {
                return String(n).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.")
            }
        },
        beforeCreate() {
        },
        created () {
        },
    }
</script>

<style lang="scss">
    @import '@/styles/components/sales/sales-land-partials/land-main.scss';
     @import '@/styles/respond/sales/sales-land-partials/land-main-respond.scss';
    // @import '@/styles/respond/sales/respond-sale-item.scss';
</style>